<template>
  <div v-loading="loading" class="user-info">
    <page-header title="个人信息修改" style="margin-bottom: 40px" />
    <!-- <el-divider content-position="left">个人信息修改</el-divider> -->
    <el-form ref="form" :rules="rules" :model="userForm" label-width="120px" label-position="left">
      <el-form-item label="证件照片">
        <ming-upload type="avatar" :headimg.sync="userForm.headimg" />
      </el-form-item>
      <div class="row">
        <el-form-item label="姓名">
          <el-input v-model="userForm.name" disabled placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="userForm.sex">
            <el-radio v-for="item in userPorlatData.sex" :key="item.id" :label="+item.id">{{ item.title }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="班级">
          <el-input v-model="userForm.className" disabled placeholder="请输入班级名称" />
        </el-form-item>
        <el-form-item label="民族">
          <el-select v-model="userForm.nation" placeholder="请选择民族">
            <el-option v-for="item in userPorlatData.nation" :key="item.id" :label="item.title" :value="+item.id" />
          </el-select>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="学号">
          <el-input v-model="userForm.idnumber" disabled placeholder="请输入学号" />
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker v-model="userForm.birthday" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" />
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="手机号" prop="mobile">
          {{ userForm.mobile }} <el-button type="text" @click="changeMobileFunc">修改</el-button>
          <!-- <el-input v-model="userForm.mobile" placeholder="请输入手机号" clearable /> -->
        </el-form-item>
        <el-form-item label="证件类型">
          <el-select v-model="userForm.idtype" placeholder="请选择证件类型">
            <el-option v-for="item in userPorlatData.idtype" :key="item.id" :label="item.title" :value="+item.id" />
          </el-select>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" placeholder="请输入邮箱" clearable />
        </el-form-item>
        <el-form-item label="证件号">
          <el-input v-model="userForm.idcard" placeholder="请输入证件号" clearable />
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="婚姻状况">
          <el-select v-model="userForm.marital_status" placeholder="请选择婚姻状况">
            <el-option v-for="item in userPorlatData.marital_status" :key="item.id" :label="item.title" :value="+item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌">
          <el-select v-model="userForm.politics" placeholder="请选择政治面貌">
            <el-option v-for="item in userPorlatData.politics" :key="item.id" :label="item.title" :value="+item.id" />
          </el-select>
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="工作年限">
          <el-input v-model="userForm.work_time" placeholder="请输入工作年限" onkeyup="value=value.replace(/[^\d]/g, '')">
            <i slot="suffix"> 年 </i>
          </el-input>
        </el-form-item>
        <el-form-item label="紧急联系人">
          <el-input v-model="userForm.emergency_people" placeholder="请输入紧急联系人姓名" clearable />
        </el-form-item>
      </div>
      <div class="row">
        <el-form-item label="紧急联系人电话" prop="phone">
          <el-input v-model="userForm.emergency_phone" placeholder="请输入紧急联系人电话" clearable />
        </el-form-item>
      </div>
    </el-form>
    <page-header title="项目信息" style="margin: 40px 0 20px 0" />
    <el-descriptions>
      <el-descriptions-item label="项目">{{ userForm.classProject || '-' }}</el-descriptions-item>
      <el-descriptions-item label="班级">{{ userForm.className || '-' }}</el-descriptions-item>
      <el-descriptions-item label="入学时间">{{ userForm.admissionTime || '-' }}</el-descriptions-item>
    </el-descriptions>
    <page-header title="教育信息" style="margin: 40px 0">
      <el-button type="text" icon="el-icon-plus" @click="openDialogEdu">添加</el-button>
    </page-header>
    <ming-table v-model="EduTableData" :fields="educolumn">
      <template #date="{ scope }">
        {{ scope.start_time }}
        &nbsp;至&nbsp;
        {{ scope.end_time }}
      </template>
      <template #degree="{ scope }">
        {{ degreeFormat(scope.degree) }}
      </template>
      <template #options="{ scope }">
        <el-button type="text" @click="delEduItem(scope)">删除</el-button>
        <el-button type="text" @click="editEduItem(scope)">修改</el-button>
      </template>
    </ming-table>

    <page-header title="工作履历" style="margin: 40px 0 20px 0">
      <el-button type="text" icon="el-icon-plus" @click="openDialogWork">添加</el-button>
    </page-header>
    <ming-table v-model="WorkInfoTabelData" :fields="column">
      <template #date="{ scope }">
        {{ scope.start_time }}
        &nbsp;至&nbsp;
        {{ scope.end_time }}
      </template>
      <template #options="{ scope }">
        <el-button type="text" @click="delWorkItem(scope)">删除</el-button>
        <el-button type="text" @click="editWorkItem(scope)">修改</el-button>
      </template>
    </ming-table>

    <div class="btn-group">
      <el-button type="primary" @click="updateInfo">确定</el-button>
      <el-button type="primary">取消</el-button>
    </div>

    <dialog-edu-info v-if="dialogEdu" :visible.sync="dialogEdu" :data="EduItemData" :title="DialogEduTitle" @add="AddEduInfo" @edit="EditEduInfo" />
    <dialog-work-info v-if="dialogWork" :visible.sync="dialogWork" :data="WorkItemData" :title="DialogWorkTitle" @add="AddWorkInfo" @edit="EditWorkInfo" />
    <change-mobile-dialog v-if="mobileVisible" :visible.sync="mobileVisible" :old-mibile="userForm.mobile" @toUpdate="getUserInfo" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { workInfoColumn, eduInfoColumn } from './tableColumn'
import PageHeader from '@/components/PageHeader'
import API from '@/api'
import { validateField } from '@/utils/validate'
import DialogEduInfo from './components/DialogEduInfo.vue'
import DialogWorkInfo from './components/DialogWorkInfo.vue'
import ChangeMobileDialog from './components/ChangeMobileDialog.vue'
import MingUpload from '@/components/MingUpload'
import Store from '@/store'
import { MessageBox, Message } from 'element-ui'

const loading = ref(false)

function degreeFormat(typeID) {
  if (!typeID) {
    return ''
  }
  const id = '' + typeID
  return userPorlatData.value.degree.filter(item => item.id === id)[0].title
}

const userForm = ref({
  name: '',
  region: '',
  work_time: null, // 工作年限
  emergency_people: '', // 紧急联系人
  emergency_phone: '', // 紧急联系电话
  enrollment: '', // 入学年月
  headimg: '', // 头像
  email: '', // 邮箱
  className: '', // 班级
  idnumber: '', // 学号
  marital_status: '', // 婚姻状况
  mobile: '', // 手机号
  sex: '', // 性别
  birthday: '', // 出生日期
  politics: '', // 政治面貌
  nation: '', // 民族
  idtype: '', // 证件类型
  eduInfo: [], // 教育信息
  workInfo: [] // 工作履历
})

/* 获取用户信息 */
function getUserInfo() {
  API.userInfo().then(res => {
    if (+res.code === 200) {
      mobileVisible.value = false
      userForm.value = { ...userForm.value, ...res.data }
      Store.commit('user/SET_USER_INFO', res.data)
    }
  })
}

/* 更改用户手机号 */
const mobileVisible = ref(false)
function changeMobileFunc() {
  mobileVisible.value = true
}

const column = ref(workInfoColumn)
const educolumn = ref(eduInfoColumn)
/* 教育信息表单弹窗 */
const dialogEdu = ref(false)
const DialogEduTitle = ref('')
const EduTableData = computed(() => {
  if (!userForm.value.eduInfo) {
    return []
  }
  return userForm.value.eduInfo
})
const EduItemData = ref({})
function openDialogEdu() {
  EduItemData.value = {}
  DialogEduTitle.value = '添加教育信息'
  dialogEdu.value = true
}
/* 添加教育信息 */
function AddEduInfo(data) {
  const deepCloneData = JSON.parse(JSON.stringify(data))
  if (userForm.value.eduInfo === null) {
    userForm.value.eduInfo = []
    userForm.value.eduInfo.push(deepCloneData)
  } else {
    userForm.value.eduInfo.push(deepCloneData)
  }
}
/* 删除教育信息 */
function delEduItem(data) {
  if (!data) return
  MessageBox.confirm('您确定删除这条教育信息吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(_ => {
    const index = userForm.value.eduInfo.indexOf(data)
    userForm.value.eduInfo.splice(index, 1)
  })
}

const eduCurIndex = ref(-1)

/* 打开修改弹窗 */
function editEduItem(data) {
  dialogEdu.value = true
  DialogEduTitle.value = '修改教育信息'
  EduItemData.value = data
  eduCurIndex.value = userForm.value.eduInfo.indexOf(data)
}

/* 修改 */
function EditEduInfo(data) {
  const newTable = userForm.value.eduInfo.map((item, index) => {
    if (index === eduCurIndex.value) {
      item = data
    }
    return item
  })
  userForm.value.eduInfo = newTable
  eduCurIndex.value = -1
  EduItemData.value = {}
}

/* 工作履历弹窗 */
const dialogWork = ref(false)
const DialogWorkTitle = ref('')
const WorkItemData = ref({})
const WorkInfoTabelData = computed(() => {
  if (!userForm.value.workInfo) return []
  return userForm.value.workInfo
})
const workCurIndex = ref(-1)
function openDialogWork() {
  DialogWorkTitle.value = '添加工作履历'
  dialogWork.value = true
  WorkItemData.value = {}
}

/* 添加工作履历 */
function AddWorkInfo(data) {
  const deepCloneData = JSON.parse(JSON.stringify(data))
  if (userForm.value.workInfo === null) {
    userForm.value.workInfo = []
    userForm.value.workInfo.push(deepCloneData)
  } else {
    userForm.value.workInfo.push(deepCloneData)
  }
}
/* 删除工作履历 */
function delWorkItem(data) {
  if (!data) return
  const index = userForm.value.workInfo.indexOf(data)
  userForm.value.workInfo.splice(index, 1)
}

/* 打开修改弹窗 */
function editWorkItem(data) {
  dialogWork.value = true
  DialogWorkTitle.value = '修改工作履历'
  WorkItemData.value = data
  workCurIndex.value = userForm.value.workInfo.indexOf(data)
}
/* 修改 */
function EditWorkInfo(data) {
  const newTable = userForm.value.workInfo.map((item, index) => {
    if (index === workCurIndex.value) {
      item = data
    }
    return item
  })
  userForm.value.workInfo = newTable
  workCurIndex.value = -1
  WorkItemData.value = {}
}

const rules = ref({
  mobile: { validator: validateField('mobile') },
  email: { validator: validateField('email') }
})

/* 获取下拉条件数据 */
const userPorlatData = computed(() => {
  return Store.state.common.UserPortalData || []
})
/* 提交用户更改信息 */
function updateInfo() {
  loading.value = true
  API.UpdateInfo(userForm.value)
    .then(res => {
      loading.value = false
      if (res.code === 200) {
        Message.success(res.msg)
        getUserInfo()
      } else {
        Message.error(res.msg)
      }
    })
    .catch(_ => {
      loading.value = false
    })
}

onMounted(() => {
  getUserInfo()
  Store.dispatch('common/UserPortalData')
})
</script>

<style lang="scss" scoped>
.user-info {
  padding-right: 10px;
  box-sizing: border-box;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    width: 40%;
  }
}
:deep(.el-date-editor) {
  width: 100% !important;
}
:deep(.el-select) {
  width: 100%;
}
.btn-group {
  margin-top: 20px;
}
</style>
